module.exports = "/assets/data/57c95c6e1836d2a9f481a7fc0647db67-WS2.data.json";